import React from "react";
import { Helmet } from 'react-helmet';

class RamspergerLandingPage extends React.Component {
    render() {

        const styleContent = `
            .lom-box-grau {
            background-color: #f1f1f1;
            padding: 20px 25px 5px;
            }

            .lom-box-h1 {
            background: var(--shop-main);
            padding: 20px 25px 10px 25px;
            color: #fff;
            margin-bottom: 30px;
            }

            .lom-box-kategorie {
            background: #fff;
            text-align: center;
            box-shadow: 0 5px 15px rgba(0,0,0,.08);
            padding: 15px;
            height: 100%;
            }

            .lom-box-kategorie img {
            margin-bottom: 10px;
            max-width: 150px;
            }

            .fake-h2 {
            font-size:  1.375rem;
            line-height: 1.3;
            font-weight: 600;
            }

            .lom-faq-details {
            background: #f1f1f1;
            margin-bottom: 1rem;
            }

            .lom-faq-antwort {
            padding: 1rem 1rem 1px 1rem;
            }


            .lom-faq-summary {
            padding: 1rem;
            background: var(--shop-main);
            color: #fff;
            cursor: pointer;
            }

            .lom-button-kategorie {
            color: #fff;
            background-color: var(--shop-main);
            curser: pointer;
            display: inline-block;
            font-weight: 400;
            text-align: center;
            white-space: nowrap;
            vertical-align: middle;
            user-select: none;
            border: 1px solid transparent;
            padding: 0.375rem 0.75rem;
            font-size: 1rem;
            line-height: 1.5;
            transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
            width: 100%;
            text-decoration: none;
            text-transform: uppercase;
            }

            .lom-button-kategorie:hover {
            background-color: #c03318;
            color: #fff;
            }

            .lom-button-ausrichtung {
            vertical-align:  middle;
            text-align: right;
            }

            .lom-zweispaltig {  display: grid;
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 0px 20px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
            margin-bottom: 30px;
            }

            .lom-zweispaltig-spalte-1 { grid-area: lom-zweispaltig-spalte-1; }
            .lom-zweispaltig-spalte-2 { grid-area: lom-zweispaltig-spalte-2; }

            .lom-vierspaltig {  display: grid;
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: 1fr;
            gap: 0px 20px;
            grid-auto-flow: row;
            grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }

            .lom-vierspaltig-spalte-1 { grid-area: lom-vierspaltig-spalte-1; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-2 { grid-area: lom-vierspaltig-spalte-2; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-3 { grid-area: lom-vierspaltig-spalte-3; margin-bottom: 20px; }
            .lom-vierspaltig-spalte-4 { grid-area: lom-vierspaltig-spalte-4; margin-bottom: 20px; }

            @media only screen and (max-width: 640px) {
            .lom-zweispaltig {
                display: block;
                grid-template-columns: 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 10px 0px;
                grid-auto-flow: row;
                grid-template-areas:
                "lom-zweispaltig-spalte-1 lom-zweispaltig-spalte-2";
            }

            .lom-zweispaltig-spalte-1 { grid-area: lom-zweispaltig-spalte-1; }
            .lom-zweispaltig-spalte-2 { grid-area: lom-zweispaltig-spalte-2; }

            .lom-vierspaltig {
                display: block;
                grid-template-columns: 1fr 1fr 1fr 1fr;
                grid-template-rows: 1fr;
                gap: 10px 0px;
                grid-auto-flow: row;
                grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2 lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }

            .lom-vierspaltig-spalte-1 { grid-area: lom-vierspaltig-spalte-1; }
            .lom-vierspaltig-spalte-2 { grid-area: lom-vierspaltig-spalte-2; }
            .lom-vierspaltig-spalte-3 { grid-area: lom-vierspaltig-spalte-3; }
            .lom-vierspaltig-spalte-4 { grid-area: lom-vierspaltig-spalte-4; }

            .lom-button-ausrichtung {
                vertical-align: middle;
                text-align: left;
            }
            }

            @media (max-width: 1240px) {
            .lom-vierspaltig {
                grid-template-columns: 1fr 1fr;
                grid-template-areas:
                "lom-vierspaltig-spalte-1 lom-vierspaltig-spalte-2"
                "lom-vierspaltig-spalte-3 lom-vierspaltig-spalte-4";
            }
            }
            `;
        return (
            <div className="uk-container">
                <Helmet>
                    <script type="application/ld+json">
                        {`{
                            "@context": "https://schema.org",
                            "@type": "FAQPage",
                            "mainEntity": [
                                {
                                "@type": "Question",
                                "name": "Welches Audi-Zubehör passt zu meinem Modell?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Das hängt von Modell, Baujahr und Ausstattungsvariante ab. Prüfen Sie vor dem Kauf die Kompatibilitätsangaben oder kontaktieren Sie Ramsperger, wenn Sie unsicher sind."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Gibt es bei Ramsperger originales Audi-Zubehör?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Ja. Das Sortiment umfasst Original-Audi-Zubehör und geprüfte Markenprodukte, kein Graumarktware, keine Nachbauten."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Kann ich Zubehör auch einbauen lassen?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Bei ausgewählten Produkten, besonders bei technischer Nachrüstung, ist der Einbau in der Ramsperger-Fachwerkstatt möglich."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Kann ich Audi-Zubehör auch vor Ort abholen?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Ja, je nach Verfügbarkeit ist die Abholung vor Ort im Ramsperger-Autohaus möglich."
                                }
                                },
                                {
                                "@type": "Question",
                                "name": "Eignet sich Audi-Zubehör als Geschenk?",
                                "acceptedAnswer": {
                                    "@type": "Answer",
                                    "text": "Durchaus. Merchandise-Artikel wie Schlüsselanhänger, Caps oder Jacken eignen sich gut als Geschenkidee für Audi-Fans, auch ohne genaue Kenntnis des Modells."
                                }
                                }
                            ]
                            }`}
                    </script>
                    <style type="text/css">{styleContent}</style>
                </Helmet>
                <img style={{ marginTop: 50 }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/audi-zubehoer-header-ramsperger.jpg" width="1200" alt="Audi Autohaus Ramsperger" />
                <div class="lom-box-h1">
                    <h1 style={{ color: "#fff" }}>Original Audi-Zubeh&ouml;r</h1>
                </div>

                <p>Ob Schutz f&uuml;r den Alltag, Technik zum Nachr&uuml;sten oder Lifestyle mit den vier Ringen: Bei Ramsperger finden Sie Audi-Zubeh&ouml;r, das zu Ihrem Fahrzeug und Ihrem Anspruch passt.</p>

                <h2>Audi-Au&szlig;enzubeh&ouml;r</h2>

                {/* CATEGORY BLOCKS */}
                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Ringe",
                            img: "audi-zubehoer-ringe.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-ringe",
                        },
                        {
                            title: "Schriftzüge",
                            img: "audi-zubehoer-schriftzuege-a6.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-schriftzuege",
                        },
                        {
                            title: "Dekorfolien",
                            img: "audi-zubehoer-dekorfolien.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-dekorfolien",
                        },
                        {
                            title: "Auspuffblenden",
                            img: "audi-zubehoer-auspuffblenden.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-auspuffblenden",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Felgen",
                            img: "audi-zubehoer-felge.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-felgen",
                        },
                        {
                            title: "Winterkompletträder",
                            img: "audi-zubehoer-winterkomplettraeder.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-winterkomplettraeder",
                        },
                        {
                            title: "Schneeketten",
                            img: "audi-zubehoer-schneeketten.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-schneeketten",
                        },
                        {
                            title: "Naben- & Radkappen",
                            img: "audi-zubehoer-naben-radkappen.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-radkappen",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Dachboxen",
                            img: "audi-zubehoer-dachboxen.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-dachboxen",
                        },
                        {
                            title: "Dachträger",
                            img: "audi-zubehoer-dachtraeger.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-dachtraeger",
                        },
                        {
                            title: "Fahrradträger",
                            img: "audi-zubehoer-fahrradtraeger.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-fahrradtraeger",
                        },
                        {
                            title: "Schmutzfänger",
                            img: "audi-zubehoer-schmutzfaenger.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-schmutzfaenger",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <h2>Audi-Innenraumzubeh&ouml;r</h2>
                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Fußmatten",
                            img: "audi-zubehoer-fussmatten.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-fussmatten",
                        },
                        {
                            title: "Kofferraummatten",
                            img: "audi-zubehoer-kofferraummatten.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-kofferraumwannen",
                        },
                        {
                            title: "Trenngitter",
                            img: "audi-zubehoer-trenngitter.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-trenngitter",
                        },
                        {
                            title: "Duftspender & -geckos",
                            img: "audi-zubehoer-duftspender.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-duftgecko-duftspender",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <h2>Audi-Nachr&uuml;stzubeh&ouml;r</h2>
                <div className="lom-vierspaltig">
                    {[
                        {
                            title: "Smartphone Interface",
                            img: "audi-zubehoer-smartphone-interface.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-smartphone-interface",
                        },
                        {
                            title: "Dashcam",
                            img: "audi-zubehoer-dashcam.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-dashcam",
                        },
                        {
                            title: "Rückfahrkamera",
                            img: "audi-zubehoer-rueckfahrkamera.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-rueckfahrkamera-nachruesten",
                        },
                        {
                            title: "Einparkhilfe",
                            img: "audi-zubehoer-einparkhilfe.webp",
                            href: "https://shop.ramsperger-automobile.de/audi-einparkhilfe-nachruesten",
                        },
                    ].map((item, i) => (
                        <div className={`lom-vierspaltig-spalte-${i + 1}`} key={i}>
                            <div className="lom-box-kategorie">
                                <h3>
                                    Audi <br />
                                    {item.title}
                                </h3>
                                <img
                                    src={`https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/${item.img}`}
                                    style={{ maxWidth: "150px" }}
                                    alt={`Audi ${item.title}`}
                                />
                                <a className="lom-button-kategorie" href={item.href}>
                                    Zur Kategorie
                                </a>
                            </div>
                        </div>
                    ))}
                </div>

                <div class="lom-vierspaltig">
                    <div class="lom-vierspaltig-spalte-1">
                        <div class="lom-box-kategorie">
                            <h3>Audi <br />Tempomat</h3>
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/audi-zubehoer-tempomat.webp" alt="Audi Tempomat" />
                            <a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-tempomat-nachruesten">Zur Kategorie</a>
                        </div>
                    </div>
                    <div class="lom-vierspaltig-spalte-2">
                    </div>
                    <div class="lom-vierspaltig-spalte-3">
                    </div>
                    <div class="lom-vierspaltig-spalte-4">
                    </div>
                </div>

                <h2>Audi-Merchandise</h2>
                <div class="lom-vierspaltig">
                    <div class="lom-vierspaltig-spalte-1">
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/bekleidung-kaufen">Audi Kleidung</a></p>
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-jacken">Audi Jacken</a></p>
                    </div>
                    <div class="lom-vierspaltig-spalte-2">
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-shirts">Audi Shirts</a></p>
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-caps-muetzen">Audi Caps</a></p>
                    </div>
                    <div class="lom-vierspaltig-spalte-3">
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-taschen-rucksaecke">Audi Taschen & Rucks&auml;cke</a></p>
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-sonnenbrillen">Audi Sonnenbrillen</a></p>
                    </div>
                    <div class="lom-vierspaltig-spalte-4">
                        <p><a class="lom-button-kategorie" href="https://shop.ramsperger-automobile.de/audi-schluesselanhaenger">Audi Schl&uuml;sselanh&auml;nger</a></p>
                    </div>
                </div>

                <h2>Ihre Vorteile im Ramsperger-Shop</h2>
                <div class="lom-vierspaltig" style={{ marginBottom: "50px" }}>
                    <div class="lom-vierspaltig-spalte-1">
                        <div class="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check-rot.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="" />
                            <p><strong>Original Audi-Qualit&auml;t</strong></p>
                            <p>Passgenaues Zubeh&ouml;r und Ersatzteile in Original- bzw. gepr&uuml;fter Qualit&auml;t f&uuml;r eine sichere, langlebige Aufwertung Ihres Audi.</p>
                        </div>
                    </div>
                    <div class="lom-vierspaltig-spalte-2">
                        <div class="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check-rot.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="" />
                            <p><strong>Gro&szlig;e Auswahl f&uuml;r Ihren Audi</strong></p>
                            <p>Von Innen- und Au&szlig;enzubeh&ouml;r &uuml;ber Ersatzteile bis zu Accessoires finden Sie passende Produkte f&uuml;r Pflege, Komfort und Individualisierung.</p>
                        </div>
                    </div>
                    <div class="lom-vierspaltig-spalte-3">
                        <div class="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check-rot.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="" />
                            <p><strong>Kompetenz vom Audi-Partner</strong></p>
                            <p>Als erfahrener Audi Partner verbindet Ramsperger Automobile Online-Shopping mit Fachhandels- und Servicekompetenz.</p>
                        </div>
                    </div>
                    <div class="lom-vierspaltig-spalte-4">
                        <div class="lom-box-kategorie">
                            <img src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/icon-check-rot.png" style={{ maxWidth: "30px", marginTop: "15px" }} alt="" />
                            <p><strong>Schnell das passende Teil finden</strong></p>
                            <p>Nutzen Sie unseren telefonischen Support oder das Kontaktformular &ndash; wir helfen Ihnen beim Produktcheck oder der Auftragsabwicklung.</p>
                        </div>
                    </div>
                </div>

                <div class="lom-zweispaltig" style={{ marginBottom: "40px" }}>
                    <div class="lom-zweispaltig-spalte-1">
                        <h2>Audi-Zubeh&ouml;r: Schutz und Komfort f&uuml;r den t&auml;glichen Einsatz</h2>
                        <p>Im Alltag gelangen schnell Schmutz, N&auml;sse und Abrieb ins Fahrzeug &ndash; besonders in den Fu&szlig;raum und den Kofferraum. Fu&szlig;matten aus Gummi oder Textil, eine passende Kofferraummatte und Schmutzf&auml;nger f&uuml;r au&szlig;en sch&uuml;tzen vor Schmutz, Feuchtigkeit und Abnutzung.</p>
                        <p>F&uuml;r das gewisse Etwas im Innenraum sorgen Duftspender und Duftgecko aus unserem offiziellen Audi-Zubeh&ouml;r-Shop.</p>
                    </div>
                    <div class="lom-zweispaltig-spalte-2 lom-box-grau">
                        <p><strong>Beliebt f&uuml;r den Alltag:</strong></p>
                        <ul>
                            <li>Audi-Fu&szlig;matten (Gummi oder Textil)</li>
                            <li>Audi-Kofferraummatte</li>
                            <li>Audi-Schmutzf&auml;nger</li>
                            <li>Audi-Duftspender / Audi-Duftgecko</li>
                            <li>Audi-Eiskratzer</li>
                        </ul>
                    </div>
                </div>

                <div class="lom-zweispaltig">
                    <div class="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: "10px" }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/audi-zubehoer-dachbox-auf-auto.jpg" alt="Audi mit Audi Dachbox" />
                    </div>
                    <div class="lom-zweispaltig-spalte-2">
                        <h2>Audi-Zubeh&ouml;r f&uuml;r Reise, Transport und jede Jahreszeit</h2>
                        <p>Sommerurlaub, Wochenendtrip oder der erste Schnee: Je nach Jahreszeit und Vorhaben braucht der Audi anderes Zubeh&ouml;r. <strong>Audi-Dachtr&auml;ger</strong> schaffen die Basis f&uuml;r Dachboxen und Fahrradtr&auml;ger, wenn mehr Stauraum f&uuml;r Reisen gefragt ist. Winterkomplettr&auml;der und Schneeketten sorgen daf&uuml;r, dass k&auml;ltere Monate keine &Uuml;berraschungen bereithalten.</p>
                        <h2>Design und Individualisierung mit dem passenden Audi-Zubeh&ouml;r</h2>
                        <p>Gezielte Akzente ver&auml;ndern das Erscheinungsbild des Fahrzeugs ohne gro&szlig;e Eingriffe. <strong>Audi-Ringe, Schriftz&uuml;ge, Spiegelkappen, Auspuffblenden, Radkappen </strong>und<strong> Dekorfolien</strong> setzen an der Front, dem Heck oder der Seite sichtbare Zeichen. Wer den Look grundlegend ver&auml;ndern m&ouml;chte, findet mit Audi-Felgen den wirkungsvollsten Hebel.</p>
                    </div>
                </div>

                <div class="lom-zweispaltig" style={{ marginBottom: "40px" }}>
                    <div class="lom-zweispaltig-spalte-1">
                        <h2>Technik nachr&uuml;sten</h2>
                        <p>Technisches Zubeh&ouml;r erweitert die M&ouml;glichkeiten Ihres Fahrzeugs, setzt aber die richtige Kompatibilit&auml;t voraus. Das <strong>Modell, </strong>das<strong> Baujahr</strong> und die <strong>vorhandene Ausstattung</strong> bestimmen, welche Nachr&uuml;stung infrage kommt.</p>
                        <p>Bei ausgew&auml;hlten Produkten &uuml;bernimmt die Ramsperger-Fachwerkstatt den fachgerechten Einbau.</p>
                    </div>
                    <div class="lom-zweispaltig-spalte-2 lom-box-grau">
                        <p><strong>Nachr&uuml;st-Optionen im &Uuml;berblick:</strong></p>
                        <ul>
                            <li>Audi-Smartphone-Interface</li>
                            <li>Audi-Dashcam</li>
                            <li>R&uuml;ckfahrkamera nachr&uuml;sten</li>
                            <li>Tempomat nachr&uuml;sten</li>
                            <li>Einparkhilfe nachr&uuml;sten</li>
                            <li>Audi-Trenngitter</li>
                        </ul>
                    </div>
                </div>

                <div class="lom-zweispaltig">
                    <div class="lom-zweispaltig-spalte-1">
                        <img style={{ marginBottom: "10px" }} src="https://techno-images.s3.eu-central-1.amazonaws.com/technoImages/own-articles/audi-zubehoer-merchandise.jpg" alt="Audi Merchandise" />
                    </div>
                    <div class="lom-zweispaltig-spalte-2">
                        <h2>Audi-Merchandise und Accessoires</h2>
                        <p>Wer einen Audi f&auml;hrt, lebt die Marke oft &uuml;ber das Fahrzeug hinaus. <strong>Jacken, Caps, Shirts und Taschen</strong> aus der offiziellen Audi-Merchandise-Kollektion erg&auml;nzen den Markenstil im Alltag. Schl&uuml;sselanh&auml;nger oder eine <strong>Audi-Sonnenbrille</strong> eignen sich au&szlig;erdem als unkomplizierte Geschenkidee f&uuml;r Audi-Fans.</p>
                        <h2>Audi-Zubeh&ouml;r online kaufen bei Ramsperger</h2>
                        <p>Ramsperger ist autorisierter Audi-Partner und bietet Original-Zubeh&ouml;r sowie gepr&uuml;fte Markenprodukte f&uuml;r Audi, Volkswagen und ausgew&auml;hlte Skoda-Modelle. Sie bestellen bequem online und w&auml;hlen zwischen <strong>Lieferung nach Hause</strong> oder <strong>Abholung vor Ort</strong>. Wenn Zubeh&ouml;r montiert oder eingebaut werden muss, &uuml;bernimmt die Ramsperger-Fachwerkstatt auf Wunsch den fachgerechten Einbau.</p>
                        <p>St&ouml;bern Sie durch das Sortiment und finden Sie, was zu Ihrem Fahrzeug und Ihrem Alltag passt.</p>
                    </div>
                </div>

                <h2>FAQ &ndash; H&auml;ufige Fragen rund um Audi-Zubeh&ouml;r</h2>
                <details class="lom-faq-details">
                    <summary class="lom-faq-summary">
                        <strong>Welches Audi-Zubeh&ouml;r passt zu meinem Modell?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Das h&auml;ngt von Modell, Baujahr und Ausstattungsvariante ab. Pr&uuml;fen Sie vor dem Kauf die Kompatibilit&auml;tsangaben oder kontaktieren Sie Ramsperger, wenn Sie unsicher sind.</p>
                    </div>
                </details>

                <details class="lom-faq-details">
                    <summary class="lom-faq-summary">
                        <strong>Gibt es bei Ramsperger originales Audi-Zubeh&ouml;r?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Ja. Das Sortiment umfasst Original-Audi-Zubeh&ouml;r und gepr&uuml;fte Markenprodukte, kein Graumarktware, keine Nachbauten.</p>
                    </div>
                </details>


                <details class="lom-faq-details">
                    <summary class="lom-faq-summary">
                        <strong>Kann ich Zubeh&ouml;r auch einbauen lassen?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Bei ausgew&auml;hlten Produkten, besonders bei technischer Nachr&uuml;stung, ist der Einbau in der Ramsperger-Fachwerkstatt m&ouml;glich.</p>
                    </div>
                </details>

                <details class="lom-faq-details">
                    <summary class="lom-faq-summary">
                        <strong>Kann ich Audi-Zubeh&ouml;r auch vor Ort abholen?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Ja, je nach Verf&uuml;gbarkeit ist die Abholung vor Ort im Ramsperger-Autohaus m&ouml;glich.</p>
                    </div>
                </details>

                <details class="lom-faq-details">
                    <summary class="lom-faq-summary">
                        <strong>Eignet sich Audi-Zubeh&ouml;r als Geschenk?</strong>
                    </summary>
                    <div class="lom-faq-antwort">
                        <p>Durchaus. Merchandise-Artikel wie Schl&uuml;sselanh&auml;nger, Caps oder Jacken eignen sich gut als Geschenkidee f&uuml;r Audi-Fans, auch ohne genaue Kenntnis des Modells.</p>
                    </div>
                </details>
            </div>
        );
    }
}

export default RamspergerLandingPage;
